import FacilitiesModalComponent from './FacilitiesModal.component';
export default FacilitiesModalComponent;